import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { isAndroid, isIOS } from "react-device-detect";
import { StaticImage } from "gatsby-plugin-image";

const Stores = () => {
  return (
    <>
      <Container fluid>
        <Row style={{ margin: "auto", maxWidth: "min(32vw, 400px)" }}>
          {((!isAndroid && !isIOS) || isAndroid) && (
            <Col
              style={{ minWidth: "80px", maxWidth: "200px", margin: "auto" }}
            >
              <div
                style={{ cursor: "pointer" }}
                onClick={() => {
                  const aToPage = document.createElement("a");
                  aToPage.setAttribute(
                    "href",
                    "https://play.google.com/store/apps/details?id=com.mawulisa.casham"
                  );
                  aToPage.setAttribute("target", "_blank");
                  aToPage.setAttribute("rel", "noopener noreferrer");
                  aToPage.click();
                }}
              >
                <StaticImage
                  src="../images/googleStore.png"
                  alt="Google Store"
                />
              </div>
            </Col>
          )}
          {((!isAndroid && !isIOS) || isIOS) && (
            <Col
              style={{ minWidth: "80px", maxWidth: "200px", margin: "auto" }}
            >
              <div
                style={{ cursor: "pointer" }}
                onClick={() => {
                  const aToPage = document.createElement("a");
                  aToPage.setAttribute(
                    "href",
                    "https://apps.apple.com/mx/app/casham/id1493246036"
                  );
                  aToPage.setAttribute("target", "_blank");
                  aToPage.setAttribute("rel", "noopener noreferrer");
                  aToPage.click();
                }}
              >
                <StaticImage src="../images/iosStore.png" alt="Ios Store" />
              </div>
            </Col>
          )}
        </Row>
      </Container>
    </>
  );
};

export default Stores;
